module.exports = __webpack_public_path__ + "assets/img/btn-back-584e8030.png";